import {AfterViewChecked, Component, Input, OnDestroy, QueryList, ViewChildren} from '@angular/core';
import {ControlContainer, NgForm, NgModel} from '@angular/forms';

import {EditModalSectionBaseComponent} from '../edit-modal-section-base.component';
import {EditModalService} from '../../../services/edit-modal.service';
import {MyDeviceRequestContainerModel} from '../../../models/my-device-request-container.model';
import {MyNotDeviceRequestContainerModel} from '../../../models/my-not-device-request-container.model';
import {ProductModel} from '../../../models/product.model';
import {Subscription} from 'rxjs';
import {IModalDialog} from '@brother-apps/brother-dealerapp-shared-lib';
import {ProductCategoryTypeEnum} from '../../../enums/product-category-type.enum';
import {MyContainersTableIdEnum} from '../../../enums/my-containers-table-id.enum';
import {AddDevicesToOrderModalComponent} from '../../add-devices-to-order-modal/add-devices-to-order-modal.component';
import {EnumUtils} from '../../../utils/enum.utils';
import {ModalDynamicV3Service} from '../../../../../shared-modal-dynamic/services/modal-dynamic-v3-service.service';
import {IModalDialogV3} from '../../../../../shared-modal-dynamic/interfaces/i-modal-dialog-v3';

// used on 3. step to list selected devices

@Component({
    selector: 'app-projects-devices-table-editor',
    templateUrl: './devices-table.component.html',
    styleUrls: ['./devices-table.component.scss'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class ProjectsDevicesTableComponent extends EditModalSectionBaseComponent implements OnDestroy, AfterViewChecked {

    @Input() public forceFormValidationVisibility: boolean;

    private changesSub: Subscription;

    public activeSpinnerId = '';
    public addArticleNumberSpinnerID = 'AddArticleNumberSpinnerID';
    private spinnerSubscription: Subscription;

    private tableValidatorsInitialized = false;


    @ViewChildren('dynamicInput') dynamicInputs: QueryList<NgModel>;
    private tableDataSourceChangedSubscription: Subscription;

    constructor(
        public  editModalService: EditModalService,
        private modalDynamicV3Service: ModalDynamicV3Service) {

        super(editModalService);
        this.spinnerSubscription = this.editModalService.activeSpinnerIdChangeAnnounced$.subscribe(spinnerId => {
            setTimeout(_ => {
                this.activeSpinnerId = spinnerId;
            }, 0);
        });

        this.tableDataSourceChangedSubscription = this.editModalService.tableContentChangedAnnounced$.subscribe(announcedTableId => {

            // updateActiveProjectContainerExistenceValidationHelperStatus was called
            console.log('tableContentChangedAnnounced$ - tableId:', EnumUtils.getKeyByValue(MyContainersTableIdEnum, announcedTableId));
            if (announcedTableId === MyContainersTableIdEnum.step3DeviceTableContainers || announcedTableId === MyContainersTableIdEnum.allTablesContainers) {
                this.activateTableValidators();
            }
        });
    }


    public onAddDeviceBtnClicked() {

        this.editModalService.announceActiveSpinnerIdChange(this.addArticleNumberSpinnerID);

        setTimeout(_ => {
            const dialogRef: IModalDialogV3 = this.modalDynamicV3Service
                .open(AddDevicesToOrderModalComponent, {
                    model: {hideSpinner: true}
                });
            dialogRef.subscribe((val: { containers: MyDeviceRequestContainerModel[], action: 'SUBMIT' | 'RESET' }) => {
                this.HandleAddDeviceToOrderModalResult(val, dialogRef);
            });
        }, 100);

    }

    private HandleAddDeviceToOrderModalResult(
        val: { containers: MyDeviceRequestContainerModel[], action: 'SUBMIT' | 'RESET' },
        dialogRef: IModalDialog) {

        if (val.action === 'SUBMIT') {
            this.editModalService.refreshRequestedNotSupplyNotServicesNotCustomContainers(MyContainersTableIdEnum.step3DeviceTableContainers);
        } else {
            // val.action === 'RESET'
            this.editModalService.resetRequestedProductContainersChanges();
            this.activateTableValidators();
        }

        this.activeSpinnerId = ''; // just for sure, in the IE the spinner deactivating via dialog sometime does not work

        this.editModalService.updateActiveProjectContainerExistenceValidationHelperStatus();

    }


    public onRemoveItemBtnClicked(itemContainer: MyDeviceRequestContainerModel | MyNotDeviceRequestContainerModel) {
        itemContainer.containerSharedMetadata.addToProductOrderList = false;
        // note: speed can be increased by removing only dedicated item form RequestedProductContainers
        //       instead of refreshing whole RequestedProductsContainers
        this.editModalService.refreshRequestedNotSupplyNotServicesNotCustomContainers(MyContainersTableIdEnum.step3DeviceTableContainers);
    }

    private activateTableValidators() {
        // console.log('this.dynamicInputs', this.dynamicInputs);
        if (!this.changesSub) {
            this.changesSub = this.dynamicInputs.changes.subscribe(value => {

                setTimeout(_ => {
                    // console.log('updating validators', value);
                    (value as QueryList<NgModel>).forEach(item => item.control.updateValueAndValidity());
                }, 0);
                this.changesSub.unsubscribe();
                this.changesSub = undefined;
            });
        }
    }

    public isSmartPrint(device: ProductModel): boolean {
        return device.printSmart;
    }

    public isInternalUser(): boolean {
        return false;
    }

    // -----------------------

    public projectRowItemsAmountComplyRules() {
        return this.editModalService.projectContainsAnythingToOrder();
    }


    public projectHasRequestedProducts() {
        return this.editModalService.dialogModelContainsSomeRequestedDevicesContainers();
    }

    public isWarrantyProductType(itemContainer: MyNotDeviceRequestContainerModel): boolean {
        return ProductCategoryTypeEnum[itemContainer.itemToOrder.category] === ProductCategoryTypeEnum.WARRANTY;
    }


    ngAfterViewChecked(): void {
        if (!this.tableValidatorsInitialized) {
            this.tableValidatorsInitialized = true;
            if (this.dynamicInputs.length) {
                setTimeout(_ => {
                    this.dynamicInputs.forEach(item => {
                        item.control.updateValueAndValidity();
                    });
                }, 0);

            }
        }
    }


    public ngOnDestroy(): void {
        if (this.changesSub) {
            this.changesSub.unsubscribe();
        }

        if (this.spinnerSubscription) {
            this.spinnerSubscription.unsubscribe();
        }
        if (this.tableDataSourceChangedSubscription) {
            this.tableDataSourceChangedSubscription.unsubscribe();
        }
    }


    public isColorPrinter(printer: ProductModel): boolean {
        return this.editModalService.containerUtilsService.isColorPrinter(printer);
    }

    public onRemoveHardwareFromOrderBtnLicked() {
        // no hardware will be ordered
        this.model.isDeviceOrderRequested = false;
        this.editModalService.announceTableContentChanged(MyContainersTableIdEnum.step3DeviceTableContainers);
    }
}
